

import { setTekSuruculuTahminiVaris } from "../../features/topPagesMap/topPagesMapSlice";
import store from "../../store/store"
import getFutureDateAndTime from "../date/getFutureDateAndTime";


const getTekSuruculuTahminiVaris = (allDistance, remainingDistance, startDate) => {

    //! ilk koşul
    if(remainingDistance <= 70){

        const date = new Date()
        // Saat ekleme işlemi (5 saat ekleme)
        let hoursToAdd = remainingDistance / 70;
        date.setHours(date.getHours() + hoursToAdd + 3);

        // Yeni tarihi gösterelim

        store.dispatch(setTekSuruculuTahminiVaris(getFutureDateAndTime(roundToNearestHalfHour(new Date(date.toISOString())))))

    }

    //! ikinci koşul
    else{
        let date = new Date(startDate);
        let dinlenmeSuresi;
        const toplamSurusSuresi = allDistance / 70
        
        if(toplamSurusSuresi <= 4.5){
            dinlenmeSuresi = 0
        }
        else if(toplamSurusSuresi <= 9){
            dinlenmeSuresi = 1
        }
        else if(toplamSurusSuresi <= 13.5){
            dinlenmeSuresi = 12
        }
        else if(toplamSurusSuresi <= 18){
            dinlenmeSuresi = 13
        }
        else if(toplamSurusSuresi <= 22.5 ){
            dinlenmeSuresi = 24
        }
        else if(toplamSurusSuresi <= 27){
            dinlenmeSuresi = 25
        }
        else if(toplamSurusSuresi <= 31.5 ){
            dinlenmeSuresi = 36
        }
        else{
            dinlenmeSuresi = 48
        }

        
        //! +3 TR saatini ekliyoruz 
        date.setHours(date.getHours() + (parseInt(toplamSurusSuresi) + dinlenmeSuresi + 3)); 
        store.dispatch(setTekSuruculuTahminiVaris(getFutureDateAndTime(roundToNearestHalfHour(new Date(date.toISOString())))))

    }
   

}

export const roundToNearestHalfHour = (date) => {
    
    let minutes = date.getMinutes();
    
    if (minutes < 15) {
        // Dakikalar 0-14 arasındaysa önceki tam saate yuvarla
        date.setMinutes(0);
    } else if (minutes >= 15 && minutes < 45) {
        // Dakikalar 15-44 arasındaysa 30 dakikaya yuvarla
        date.setMinutes(30);
    } else {
        // Dakikalar 45 ve üstündeyse bir sonraki saate yuvarla
        date.setMinutes(0);
        date.setHours(date.getHours() + 1);
    }
    
    // Saniyeleri ve milisaniyeleri sıfırlıyoruz
    date.setSeconds(0);
    date.setMilliseconds(0);
    
    return date;
}

export default getTekSuruculuTahminiVaris